// extracted by mini-css-extract-plugin
export default {"input":"BaseLabel_input__10NU5","title":"BaseLabel_title__XP0Vo","bigTitle":"BaseLabel_bigTitle__ZkZB0","subTitle":"BaseLabel_subTitle__Px0ea","icon":"BaseLabel_icon__D9jLD"};